<div class="new-additions-container component-container">
  <div class="row">
    <div class="ui-g">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 margin-align">
        <h4 class="margin-header-align text-uppercase">Download - Center</h4>
        <hr/>
      </div>
    </div>
  </div>
  <div class="ui-g">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 margin-align">
      <div class="page-heading text-uppercase">{{'app.navigation.doc_upload' | translate | uppercase}}</div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" [formGroup]="documentsFG">
        <div class="form-background top-bottom-margin flex-row"
             *ngFor="let item of docItems.controls;let i = index" formArrayName="docItems">
          <div [formGroupName]="i" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
            <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12">
              <input class="doc-submit-inputs" pInputText type="text" formControlName="documentName"/>
            </div>
            <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
              <p-fileUpload #documentUploader (onSelect)="onUploadDocument($event, i, documentUploader)"
                            chooseLabel="{{'facilities-data.form-fields.upload-button' | translate}}"
                            [disabled]="item.value['documentName'] === ''"
                            mode="basic"></p-fileUpload>
            </div>
            <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-2 ui-sm-2 ui-xs-2 field-rows file-name-section">
              <a *ngIf="item.value['fileName']" href="javascript:void(0)"
                 (click)="downloadDocument(i, item.value['fileName'])">{{item.value['fileName']}}</a>
              <i (click)="removeEntity('document', i)" class="pi pi-trash pointer-cursor delete-icon"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
        <div class="ui-g-12 margin-align add-button-row form-font-size">
          <i (click)="addMore('document')" class="pi pi-plus plus-icon new-facility-plus-icon"
             id="add-document"></i>
          <label class="ui-g-5 field-label"
                 for="add-document">{{'facilities-data.form-fields.add-document-button' | translate}}</label>
        </div>
      </div>
    </div>

    <ng-container *ngIf="showSampleDocuments">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 margin-align sample-documents-section">
        <div class="title text-uppercase">{{'administration.sample-documents' | translate | uppercase}}</div>
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" [formGroup]="exampleDocumentsFG">
          <div class="form-background top-bottom-margin flex-row"
               *ngFor="let item of exampleDocumentsArray.controls;let i = index" formArrayName="docItems">
            <div [formGroupName]="i" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <p-dropdown [options]="documentTypes"
                            formControlName="documentType"
                            id="example-doc-type"
                            placeholder="-Select-"
                            styleClass="netz-small-dropdown">
                  <ng-template let-item pTemplate="selectedItem">
                    <span
                      class="drop-item-label">{{'lookup.' + documentTypeKey + '.options.' + item['value'] + '.name' | translate}}</span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div (click)="eventDisabled(option.inactive)"
                         [ngStyle]="option.inactive ? {backgroundColor:'#efefef', 'color': '#ccc', 'cursor': 'default'} : null"
                         class="drop-item">
                      <span
                        class="drop-item-label">{{'lookup.' + documentTypeKey + '.options.' + option['value'] + '.name' | translate}}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" pInputText type="text" formControlName="documentName"/>
              </div>
              <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload #exampleDocUploader
                              (onSelect)="onUploadExampleDocument($event, item, i, exampleDocUploader)"
                              chooseLabel="{{'facilities-data.form-fields.upload-button' | translate}}"
                              [disabled]="item.value['documentName'] === ''"
                              mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 field-rows file-name-section">
                <a *ngIf="item.value['fileName']" href="javascript:void(0)"
                   (click)="downloadExampleDocument(item.value['documentId'], item.value['fileName'])">{{item.value['fileName']}}</a>
                <i (click)="deleteExampleDocument(item.value['documentId'], i)"
                   class="pi pi-trash pointer-cursor delete-icon"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
          <div class="ui-g-12 margin-align add-button-row form-font-size">
            <i (click)="addExampleDocument()" class="pi pi-plus plus-icon new-facility-plus-icon"
               id="add-sample-document"></i>
            <label class="ui-g-5 field-label"
                   for="add-sample-document">{{'administration.add-sample-doc-button' | translate}}</label>
          </div>
        </div>
      </div>
    </ng-container>

    <div *ngIf="showNewDevAreaSection"
         class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 margin-align development-areas">
      <div class="page-heading text-uppercase">{{'administration.new-dev-area' | translate | uppercase}}</div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
        <div class="ui-g-offset-3 ui-g-8">
          <div
            class="ui-g-3 center-align area-facility-styles">{{'overview.details-data.data-rows.power' | translate}}</div>
          <div
            class="ui-g-3 center-align area-facility-styles">{{'overview.details-data.data-rows.gas' | translate}}</div>
          <div
            class="ui-g-3 center-align area-facility-styles">{{'overview.details-data.data-rows.water' | translate}}</div>
          <div
            class="ui-g-3 center-align area-facility-styles">{{'overview.details-data.data-rows.heating' | translate}}</div>
        </div>
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" [formGroup]="areasFG">
        <div *ngFor="let item of areaItems.controls;let i=index;" formArrayName="areaItems">
          <div [formGroupName]="i" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
            <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-3 ui-sm-3 ui-xs-3">
              <input pInputText type="text" formControlName="areaName" (input)="handleMediaSelectors($event, i)"/>
            </div>
            <div class="ui-g-8 ui-xl-8 ui-lg-8 ui-md-8 ui-sm-8 ui-xs-8">
              <div class="ui-g-3 center-align">
                <p-checkbox [binary]="true" formControlName="forPower"
                            (onChange)="saveOrUpdateNewArea(i,item['controls'])"></p-checkbox>
              </div>
              <div class="ui-g-3 center-align">
                <p-checkbox [binary]="true" formControlName="forGas"
                            (onChange)="saveOrUpdateNewArea(i,item['controls'])"></p-checkbox>
              </div>
              <div class="ui-g-3 center-align">
                <p-checkbox [binary]="true" formControlName="forWater"
                            (onChange)="saveOrUpdateNewArea(i,item['controls'])"></p-checkbox>
              </div>
              <div class="ui-g-3 center-align">
                <p-checkbox [binary]="true" formControlName="forHeating"
                            (onChange)="saveOrUpdateNewArea(i,item['controls'])"></p-checkbox>
              </div>
            </div>
            <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-1 ui-sm-1 ui-xs-1">
              <i (click)="removeEntity('area',i)" class="pi pi-trash pointer-cursor delete-icon"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
        <div class="ui-g-12 margin-align add-button-row form-font-size">
          <i (click)="addMore('area')" class="pi pi-plus plus-icon new-facility-plus-icon"
             id="add-area"></i>
          <label class="ui-g-5 field-label"
                 for="add-area">{{'facilities-data.form-fields.add-dev-area' | translate}}</label>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
